import type { CSSProperties } from "react";

interface MapsMiniMapSkeletonProps {
  /** The exact px footprint of the map image that will replace it. */
  width: number;
  height: number;
}

/**
 * Break glass: the placeholder that holds a MiniMap's space while its
 * coordinates are still resolving.
 *
 * Two reasons it can't compose. Its size has to match the Mapbox static image
 * exactly, and that size is a runtime number the caller passes straight into the
 * image URL. And the shimmer is a moving linear-gradient — a background image,
 * not a colour token.
 */
export function MapsMiniMapSkeleton({
  width,
  height,
}: MapsMiniMapSkeletonProps) {
  const footprint: CSSProperties = {
    width: `${width}px`,
    height: `${height}px`,
  };

  return (
    <div
      className="animate-skeleton-shimmer rounded-sm [background-image:linear-gradient(90deg,#f0f0f0_25%,#e0e0e0_50%,#f0f0f0_75%)] bg-[length:800px_100%]"
      style={footprint}
    />
  );
}
